module.exports = __webpack_public_path__ + "static/media/logo.afed59af.jpg";